import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { usePrevious } from '../../lib/utils/hooks'
import { CLIPBOARD_SYNC_STATUS } from '../../lib/clipboard'
import ToolbarButton from './ToolbarButton'
import { clipboardLocalWrite } from '../../actions/clipboard'
import { AGENT_TYPE } from '../../actions/agent'

const ClipboardButton = ({
  writeToSystemClipboard,
  clipboard: {
    enabled: clipboardEnabled,
    showClipboardButton,
    remoteText,
    remoteTextSyncStatus,
  },
  webrtcConnection: {
    unstable: connectionUnstable,
  },
  platformType,
  agentType,
}, { t: translate }) => {
  if (
    !(
      clipboardEnabled && // featured flag (per environment)
      showClipboardButton && // macos && safari >= 13
      platformType !== 'ios' && // not implemented on ios
      agentType === AGENT_TYPE.ON_DEMAND // only implemented in ondemand agents
    )
  ) {
    return null
  }

  const [clipboardButtonDisabled, setClipboardButtonDisabled] = useState(connectionUnstable)
  const [tooltipText, setTooltipText] = useState(translate('tooltip-copy-to-clipboard-hover'))
  const prevRemoteTextSyncStatus = usePrevious(remoteTextSyncStatus)
  const [showTooltip, setShowTooltip] = useState(false)

  useEffect(() => {
    const shouldShowTooltip = (
      !clipboardButtonDisabled &&
      remoteTextSyncStatus === CLIPBOARD_SYNC_STATUS.FAIL &&
      prevRemoteTextSyncStatus !== remoteTextSyncStatus
    )

    if (shouldShowTooltip) {
      setTooltipText(translate('tooltip-copy-to-clipboard'))
      setShowTooltip(shouldShowTooltip)
    }
  }, [remoteTextSyncStatus, clipboardButtonDisabled])

  useEffect(() => {
    setClipboardButtonDisabled(connectionUnstable)
  }, [connectionUnstable])

  return (
    <div className='tbArea'>
      <div className='tbDivider' />
      <ToolbarButton
        className={'tbClipboard'}
        tooltip={tooltipText}
        tooltipOptions={{
          activeOnDisabled: true,
          showTooltip,
        }}
        disabled={clipboardButtonDisabled}
        onClick={() => {
          setTimeout(() => setTooltipText(translate('tooltip-copy-to-clipboard-hover')), 200)
          writeToSystemClipboard({ text: remoteText })
        }}
      />
    </div>
  )
}

ClipboardButton.propTypes = {
  agentType: PropTypes.string.isRequired,
  platformType: PropTypes.string.isRequired,
  writeToSystemClipboard: PropTypes.func.isRequired,
  clipboard: PropTypes.shape({
    enabled: PropTypes.bool.isRequired,
    showClipboardButton: PropTypes.bool.isRequired,
    remoteText: PropTypes.string,
    remoteTextSyncStatus: PropTypes.string.isRequired,
  }),
  webrtcConnection: PropTypes.shape({
    unstable: PropTypes.bool,
  }),
}

ClipboardButton.contextTypes = {
  t: PropTypes.func.isRequired
}

const mapStateToProps = (state) => ({
  clipboard: state.clipboard,
  toolbar: state.toolbar,
  webrtcConnection: state.webrtcConnection,
  platformType: state.signaling.agentDetails.platformType,
  agentType: state.agent.type,
})

const mapDispatchToProps = (dispatch) => ({
  writeToSystemClipboard: (payload) => {
    dispatch(clipboardLocalWrite(payload))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(ClipboardButton)
